// ── Asset imports ─────────────────────────────────────────────────────────────
import ApexImg         from "../assets/apex.png";
import BeanHavenImg    from "../assets/beanhaven.png";
import BiyiImg         from "../assets/biyi.png";
import BricklyImg      from "../assets/brickly.png";
import CryptoplaceImg  from "../assets/Cryptoplace.png";
import FxIntelImg      from "../assets/fxintel.png";
import IBrandImg       from "../assets/ibrand.png";
import KelvinImg       from "../assets/kelvin.png";
import MicroInvestImg  from "../assets/MicroInvestor.png";
import NexaforgeImg    from "../assets/nexaforge.png";
import SaasKitImg      from "../assets/saaskit.png";
import StockTrackerImg from "../assets/StockTracker.png";
import TodoImg         from "../assets/todo.png";
import StudentNestImg from "../assets/studentnest.avif"
import toofoodyImg from "../assets/toofoody.avif"
import OrbitImg from "../assets/orbit.webp"
// ── Projects ──────────────────────────────────────────────────────────────────
export const projectsData = [
  {
    title: "Crypto-place",
    description: "A crypto tracking webapp built with React and CoinGecko API integration.",
    link: "https://cryptoplace-flame.vercel.app/",
    techStack: ["React", "Tailwind CSS", "Coingecko API"],
    screenshot: CryptoplaceImg,
  },
  {
    title: "StudentNest",
    description: "Student Nest is a housing marketplace designed to help Nigerian students find affordable accommodation directly from landlords, without agent fees.",
    link: "https://figma.com/proto/yQy46vUKLVxNCeKD2thxME/student-nest?node-id=0-1&fuid=1220725552584503689",
    techStack: ["Figma"],
    screenshot: StudentNestImg,
  },
   {
    title: "Toofoody",
    description: "This project is a modern food delivery and restaurant website designed to showcase menu items in a visually engaging and conversion-focused way.",
    link: "https://www.figma.com/proto/RgBndwLAintfXmxsAdkmUf/toofoody?node-id=18-255&p=f&t=g8RUmtfYtUHkXaqW-0&scaling=min-zoom&content-scaling=fixed&page-id=6%3A12",
    techStack: ["Figma"],
    screenshot: toofoodyImg,
  },
  {
    title: "Orbit Dashboard",
    description: "Orbit Admin Dashboard.",
    link: "https://www.figma.com/proto/k0r9nC9Lu6uxKKUZ738hQJ/orbit-admin-dashboard?node-id=1-2&p=f&t=C8Q6dHt1rUpcFZS6-0&scaling=min-zoom&content-scaling=fixed&page-id=0%3A1",
    techStack: ["Figma"],
    screenshot: OrbitImg,
  },
  {
    title: "Stock Market Tracker",
    description: "A stock market tracker integrated with Alpha Vantage and Finnhub as fallback.",
    link: "https://stockmarketracker.vercel.app/",
    techStack: ["React", "Tailwind CSS", "Alpha Vantage API"],
    screenshot: StockTrackerImg,
  },
  {
    title: "SaasKit",
    description: "Your favorite AI bundles in one place.",
    techStack: ["React", "Tailwind CSS", "Framer Motion"],
    link: "https://saaskitt.vercel.app/",
    screenshot: SaasKitImg,
  },
  {
    title: "Micro-Investor",
    description: "AI-powered micro-investment planner built with React and Tailwind.",
    techStack: ["React", "Tailwind CSS", "AI Integration"],
    link: "https://microinvestor.vercel.app/",
    screenshot: MicroInvestImg,
  },
  {
    title: "FxIntel AI",
    description: "AI-powered forex trading platform with real-time analytics.",
    techStack: ["React", "Tailwind CSS", "AI Integration"],
    link: "https://fxintelai.vercel.app/",
    screenshot: FxIntelImg,
  },
  {
    title: "Nexaforge",
    description: "Website for a web development agency.",
    techStack: ["React", "Tailwind CSS", "Framer Motion"],
    link: "https://nexaforge.pxxl.click",
    screenshot: NexaforgeImg,
  },
  {
    title: "Biyi's Portfolio",
    description: "A portfolio website for a talented designer.",
    techStack: ["Wordpress"],
    link: "https://biyi-olufunmilayo.ct.ws/?i=1",
    screenshot: BiyiImg,
  },
  {
    title: "Web3 Todo App",
    description: "Web3 Todo App using wallet address as login info.",
    techStack: ["Next.js", "Tailwind", "Wagmi"],
    link: "https://web3todoapp.pxxl.xyz/",
    screenshot: TodoImg,
  },
  {
    title: "Apex Wallet",
    description: "Landing page for a crypto wallet.",
    techStack: ["Framer"],
    link: "https://apexwallett.framer.website/",
    screenshot: ApexImg,
  },
  {
    title: "Timothy's Portfolio",
    description: "Visual Designer's portfolio.",
    techStack: ["Next.js", "Tailwind CSS"],
    link: "https://ibrand-mu.vercel.app/",
    screenshot: IBrandImg,
  },
  {
    title: "Kelvin Atc",
    description: "Landing page for a fashion stylist.",
    techStack: ["Framer"],
    link: "https://kelvinatc.framer.website/",
    screenshot: KelvinImg,
  },
  {
    title: "Bean Haven Coffee",
    description: "Website for a coffee shop.",
    techStack: ["Framer"],
    link: "https://beanhavencoffee.framer.website/",
    screenshot: BeanHavenImg,
  },
  {
    title: "Brickly",
    description: "Website for a real estate company.",
    techStack: ["Next.js", "Tailwind CSS"],
    link: "https://bricklyy.vercel.app/",
    screenshot: BricklyImg,
  },
];

// ── Skills ────────────────────────────────────────────────────────────────────
export const skillIcons = {
  React:         "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
  Javascript:    "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg",
  "Tailwind CSS":"https://cdn.jsdelivr.net/gh/devicons/devicon/icons/tailwindcss/tailwindcss-original.svg",
  CSS:           "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg",
  Git:           "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg",
  Wordpress:     "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/wordpress/wordpress-plain.svg",
  Framer:        "https://www.svgrepo.com/show/452207/framer.svg",
  "Next.js":     "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nextjs/nextjs-original.svg",
  Wagmi:         "https://moralis.com/wp-content/uploads/web3wiki/196-wagmi/637e6c001c60c5e2d8078d8c_wOdHswYe73lnRqkKuJDsSLgwRkQ9Kt831G_9nSGTEFw.png",
  Figma:         "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/figma/figma-original.svg",
};